<template>
<div>
	<div @click="handleClick" class="wheel" :style="style" v-if="this.realtimeData.state === true && mode === 'view'">
    <div class="box1" :style="{'background' : this.settings.background1}"></div>
    <div class="box2" :style="{'background' : this.settings.background2}"></div>
    <div class="box3" :style="{'background' : this.settings.background3}"></div>
    <div class="box4" :style="{'background' : this.settings.background4}"></div>
	</div>	
	<div class="wheel"  :style="style" v-if="mode === 'edit'">
    <div class="box1" :style="{'background' : this.settings.background1}"></div>
    <div class="box2" :style="{'background' : this.settings.background2}"></div>
    <div class="box3" :style="{'background' : this.settings.background3}"></div>
    <div class="box4" :style="{'background' : this.settings.background4}"></div>
	</div>
  <el-dialog :style="dialogStyle"
      title="子窗口页面"
      :visible.sync="modalShow"
      :width="realtimeData.modalValue+'px'"
      @close="modalShow=false"
      append-to-body>
    <div :style="modelStyle">
      <div style="width: 100%; ">
        <the-create style="width: 100%;" :companyId="companyId" :productId="realtimeData.pageId" :projectId="productSaveForm.projectId" :editType="3" :dialogCount="dialogCount+1" :readPublished="true"></the-create>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
	import componentsMixin from "../componentsMixin";

  export default {
    name: "wheelComponent",
    mixins: [componentsMixin],
    methods:{
      appearWheel(){
        this.settings.state = true
      },
      disappearWheel(){
        this.settings.state = false
      },
      //暂停旋转
      stopWheel(){
        this._style["animation-play-state"] = 'paused'
        this.settings.rotateState = false
         this.newSettings.rotateState = false
        console.log('点击暂停旋转',this.newSettings.rotateState)
      },
      //开始旋转
      clockWiseWheel(){
        this._style["animation-play-state"] = 'running'
        this.settings.rotateState = true
        this.newSettings.rotateState = true
        console.log('点击开始顺旋转',this.newSettings.rotateState)
      },
		},
    computed:{
      dialogStyle(){
        if(this.realtimeData.modalX === undefined && this.realtimeData.modalY === undefined ){
          var applyLeft = '0'
          var applyTop = '0'
        }else if(this.realtimeData.modalX.length == 0 && this.realtimeData.modalY.length == 0){
          var applyLeft = '0'
          var applyTop = '0'
        }else if(this.realtimeData.modalX.length !== 0 && this.realtimeData.modalY.length == 0){
          var applyLeft = this.realtimeData.modalX
          var applyTop = '0'
        } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length == 0) {
          var applyLeft = '0'
          var applyTop = this.realtimeData.modalY
        } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length !== 0) {
          var applyLeft = this.realtimeData.modalX
          var applyTop = this.realtimeData.modalY
        }
        return {
          top:`calc(${applyTop}px + 10vh)`,
          left: applyLeft + 'px',
        }
      },
    },
		watch: {
			// 彩轮转动速度
			'realtimeData.animationDuration': {  // 绑定变量 监听实际数值变化 （直接设置数值时，在编辑器处就进行了属性更新，响应快，无需再添加对settings的监听）
				handler() {
					if(parseInt(this.realtimeData.animationDuration) === 0){   // 速度为 0 停止
						this._style["animation-play-state"] = "paused"
					}
					else{  // 模拟计算旋转时长
						this._style["animation-play-state"] = "running"
						this._style['animation-duration'] = 50/parseInt(this.realtimeData.animationDuration) + 's'
					}
					
				}
			},
			// 转动/停止
			'settings.state': {
				handler(val) {
					this._style["animation-play-state"] = val
				}
			},
      // 'realtimeData.top': {  // x绑定
      //   handler() {
      //     this.wrapperStyle.top = this.realtimeData.top +'px'
      //   }
      // },
      // 'realtimeData.left': {  // y绑定
      //   handler() {
      //     this.wrapperStyle.left = this.realtimeData.left +'px'
      //   }
      // },
      // 'realtimeData.height': {  // 高度绑定
      //   handler() {
      //     this._style.height = this.realtimeData.height + 'px'  // componentsMixin 中对 _style 进行了检查更新style 绑定至矩形框
      //     this.wrapperStyle.height = this.realtimeData.height +'px'
      //   }
      // },
      // 'realtimeData.width': {  // 宽度绑定
      //   handler() {
      //     console.log("宽度发生改变",this.realtimeData.width,this.style)
      //     this._style.width = this.realtimeData.width + 'px'
      //     this.wrapperStyle.width = this.realtimeData.width +'px'  // 编辑框
      //   }
      // },
		}
	}
</script>


<style lang="less" scoped>
	@keyframes animation{
    from{
      transform:rotate(0deg)
    }
    to{
      transform:rotate(360deg);
    }
	}
	
	@keyframes animation2{
    from{
        transform:rotate(0deg)
    }
    to{
        transform:rotate(-360deg);
    }
	}
	
	.wheel{
    display:flex;
    flex-wrap:wrap;/*换行*/
   /* margin:0 auto;
    width:200px;
    height:200px;
  border-radius: 50%;
    border:1px solid red; */
    position:relative;/*相对*/
    animation-name:animation;/*动画名称*/
    animation-iteration-count:infinite;/*循环次数infinite无限循环*/
    animation-timing-function:linear;/*动画的过度类型  linear线性过渡*/
	}
	.box1{
    width:50%;
    height:25%;
    border-radius:100px 100px 0 0;/*左上角,右上角,右下角,左下角*/
    position: relative;
    top: 25%;
	}
	.box2{
    width:25%;
    height:50%;
    //background:yellow;
    border-radius:0 100px 100px 0;
	}
	.box3{
    width:25%;
    height:50%;
    //background:green;
    border-radius:100px 0 0 100px;
    //margin-top:200px;
    //margin-left:-200px;
		position: relative;
		top: 50%;
		left: -50%;
	}
	.box4{
    width:50%;
    height:25%;
    //background:purple;
    border-radius: 0 0 100px 100px ;
    //margin-top:200px;
		position: relative;
		bottom: 12.5%;
		right: -50%;
	}
  ::v-deep .el-dialog{
    margin:0 !important;
    position:absolute;
  }
</style>
